module.exports = __webpack_public_path__ + "static/media/nj.7415413d.svg";